module.exports = __webpack_public_path__ + "img/personality.76fb9c92.svg";